define.alias("ember-useragent/instance-initializers/user-agent", "settings/instance-initializers/user-agent");